export default __webpack_public_path__ + "static/media/pool-banner.a76f2d39.png";